/*
 * --------------------------------------------------------------------------- *
 * File: dataform.js                                                           *
 * Project: web                                                                *
 * Created Date: 29 Oct 2022                                                   *
 * Author: Vikas K Solegaonkar (vikas.solegaonkar@gmail.com)                   *
 * Copyright (c) 2022 Vikas K Solegaonkar                                      *
 * https://solegaonkar.com                                                     *
 *                                                                             *
 * Last Modified: Wed Nov 09 2022                                              *
 * Modified By: Vikas K Solegaonkar                                            *
 *                                                                             *
 * HISTORY:                                                                    *
 * --------------------------------------------------------------------------- *
 * Date         By     Comments                                                *
 * --------------------------------------------------------------------------- *
 */

import React, { useContext, useRef, useState } from "react";
import "../App.css";
import Constants from "../main/constants";
import { AppContext } from "../main/context";
import { checkRequiredValues } from "./datatypeutils";
import Field from "./field";
import ValidationModal from "./validationModal";

function DataForm(props) {
  const { setFlashRequired, forceRefresh, setForceRefresh, allowNextRef, setShowNow } = useContext(AppContext);
  const [tabIndex, setTabIndex] = useState(0);
  const [validationMessages, setValidationMessages] = useState([]);
  const modalResolve = useRef(() => {});

  const onSubmit = () => {
    if (props.onSubmit) {
      if (checkRequiredValues(props.data, props.structure)) {
        props.onSubmit();
      } else {
        setFlashRequired(true);
        setTimeout(() => {
          setFlashRequired(false);
        }, 500);
      }
    }
  };

  const updateField = (name, value) => {
    var u = {};
    u[name] = value;
    var data = JSON.parse(JSON.stringify(props.data));
    Object.assign(data, u);
    if (props.onChange) props.onChange(data);
  };

  const checkValidations = () =>
    new Promise((resolve, reject) => {
      setForceRefresh(!forceRefresh);
      allowNextRef.current = true;
      setTimeout((e) => {
        if (allowNextRef.current) {
          console.log("Validating");
          props.validation.check(props.data).then((messages) => {
            console.log(messages);
            if (messages.length > 0) {
              modalResolve.current = resolve;
              setValidationMessages(messages);
            } else {
              resolve(true);
            }
          });
        } else {
          setFlashRequired(true);
          setTimeout((e) => setFlashRequired(false), 500);
          resolve(false);
        }
      }, 10);
    });

  const fieldList = (fields) => {
    if (fields && fields[0]?.tab) {
      var tabTitles = [];
      fields.forEach((f) => {
        if (tabTitles.length === 0 || tabTitles[tabTitles.length - 1] !== f.tab) tabTitles.push(f.tab);
      });

      var prevButton =
        tabIndex > 0 ? (
          <div className="col-6 left">
            <button className="btn btn-sm btn-info" onClick={(e) => setTabIndex(tabIndex - 1)}>
              Prev
            </button>
          </div>
        ) : (
          <div className="col-6 left"></div>
        );

      var nextButton =
        tabIndex < tabTitles.length - 1 ? (
          <div className="col-6 right">
            <button
              className="btn btn-sm btn-info"
              onClick={async (e) => {
                if (await checkValidations()) setTabIndex(tabIndex + 1);
              }}
            >
              Next
            </button>
            <ValidationModal
              messages={validationMessages}
              setMessages={setValidationMessages}
              resolveRef={modalResolve}
            />
          </div>
        ) : (
          <div className="col-6 right">
            {props.onSubmit ? (
              <button
                className="btn btn-sm btn-danger"
                onClick={async (e) => {
                  if (await checkValidations()) onSubmit(props.data);
                }}
              >
                Submit
              </button>
            ) : (
              <></>
            )}
            <ValidationModal
              messages={validationMessages}
              setMessages={setValidationMessages}
              resolveRef={modalResolve}
            />
          </div>
        );

      var tabs = tabTitles
        .map((t) =>
          fields
            .filter((f) => f.tab === t)
            .map((f) => {
              let { tab, ...g } = f;
              return g;
            })
        )
        .map((f, i) =>
          i === tabIndex ? (
            <div key={i} className="container tab-pane">
              {fieldList(f)}
            </div>
          ) : (
            <></>
          )
        );
      tabs = <div className="">{tabs}</div>;
      return [prevButton, nextButton, tabs];
    }

    return Array.isArray(fields) ? (
      fields.map((e, j) => (
        <Field
          key={j}
          index={i++}
          type={e}
          value={props.data[e.fieldName]}
          onChange={(v) => updateField(e.fieldName, v)}
          validation={props.validation}
        />
      ))
    ) : (
      <></>
    );
  };

  var i = 0;
  if (props.structure && props.data)
    return (
      <div className="container">
        <div className="row">&nbsp;</div>
        <div className="row">
          {props.title ? (
            <div className="col-12">
              <h5 className="input-form-subtitle p-2 rounded">{props.title}</h5>
              <hr className="input-form-subtitle border" />
            </div>
          ) : (
            <></>
          )}
          {fieldList(props.structure)}
        </div>
      </div>
    );
  else return <></>;
}

export default DataForm;
